module.exports = __webpack_public_path__ + "img/sound.d61f2a77.png";